import { defineComponent as _defineComponent } from 'vue';
import { BSpinner } from "bootstrap-vue";
import { onMounted, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IdleLoad',
    props: {
        spinner: { type: Boolean },
        center: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        // This component delays the rendering of slotted elements
        // in order to not slow down the rendering of parent components,
        // or the responsiveness of the UI
        const render = ref(false);
        const idleFallbackTime = 250;
        onMounted(() => {
            if ("requestIdleCallback" in window) {
                window.requestIdleCallback(() => (render.value = true));
            }
            else {
                setTimeout(() => (render.value = true), idleFallbackTime);
            }
        });
        return { __sfc: true, props, render, idleFallbackTime, BSpinner };
    }
});
